import React from "react";
import { useAuth } from "../context/AuthContext";
import { ShieldAlert, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const { impersonatingName, stopImpersonating } = useAuth();
  if (!impersonatingName) return null;

  return (
    <div
      className="sticky top-0 z-[60] bg-[#F7C353] text-zinc-900 px-4 py-2 flex items-center justify-center gap-3 flex-wrap shadow-md"
      data-testid="impersonation-banner"
    >
      <span className="inline-flex items-center gap-2 text-sm font-semibold">
        <ShieldAlert className="w-4 h-4" />
        Modo admin · viendo como: {impersonatingName}
      </span>
      <button
        onClick={stopImpersonating}
        className="inline-flex items-center gap-1.5 text-xs font-bold bg-zinc-900 text-white px-3 py-1.5 rounded-full hover:bg-zinc-700 transition-colors"
        data-testid="impersonation-exit-btn"
      >
        <LogOut className="w-3.5 h-3.5" /> Volver a admin
      </button>
    </div>
  );
}
